/**
 * WordPress dependencies
 */
import { useMemo } from '@safe-wordpress/element';
import { type WordPressComponentProps } from '@safe-wordpress/components';

/**
 * Internal dependencies
 */
import { useContextSystem } from '../../context';
import { useCx } from '../../utils';
import * as styles from '../styles';
import type { LinkedButtonProps } from '../types';

export function useBorderBoxControlLinkedButton(
	props: WordPressComponentProps< LinkedButtonProps, 'button' >
): { className: string } & Omit<
	WordPressComponentProps< LinkedButtonProps, 'button' >,
	'className'
> {
	const {
		className,
		size = 'default',
		...otherProps
	} = useContextSystem( props, 'BorderBoxControlLinkedButton' );

	// Generate class names.
	const cx = useCx();
	const classes = useMemo( () => {
		return cx( styles.borderBoxControlLinkedButton( size ), className );
	}, [ className, cx, size ] );

	return { ...otherProps, className: classes };
}
